/**
 * CetusEd Admin Console — Application Layout
 *
 * COMPLIANCE: The admin layout includes a sidebar navigation for all admin
 *   feature areas. Protected routes require authentication. Unauthenticated
 *   access redirects to /login per ⛔ Rule 2 (fail closed).
 */

import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAdminAuth } from '../auth/useAdminAuth';
import { Sidebar } from './Sidebar';

export const ProtectedRoute: React.FC = () => {
  const auth = useAdminAuth();
  if (auth.isLoading) return <div className="admin-loading">Loading...</div>;
  if (!auth.isAuthenticated) return <Navigate to="/login" replace />;
  return <Outlet />;
};

export const Layout: React.FC = () => {
  return (
    <div className="admin-layout">
      <Sidebar />
      <div className="admin-main">
        <header className="admin-topbar">
          <h1 className="sr-only">CetusEd Admin Console</h1>
        </header>
        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
